import { useMutation, useQueryClient } from "@tanstack/react-query";
import _cookies from "../../../shared/utils/_cookies";
import { createNotification } from "../../../shared/store/notifications";

export async function deletPostImage({ postId, imageURL }) {
  const urlSearchParams = new URLSearchParams({
    postagemid: postId,
    link: "'" + encodeURIComponent(imageURL.replaceAll("\\", "/")) + "'",
  }).toString();
  const res = await fetch(
    "https://middleware.cadernovirtual.com.br/aluno.asmx/Excluir_Anexo_Postagem_link?" +
      urlSearchParams,
    {
      headers: {
        "Content-Type": "application/json",
        token: _cookies.getItem("auth").token,
      },
    }
  );
  return res;
}

export const useDeletePostImage = ({ config } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletPostImage,

    onSuccess: (data, variables) => {
      const { postId } = variables;
      queryClient.refetchQueries(["socialMediaThemePosts", { postId }]);
      createNotification({
        type: "success",
        message: "Imagem deletada com sucesso",
      });

      queryClient.invalidateQueries(["socialMediaPost", { postId }]);
    },
  });
};
